import { Component, OnInit, forwardRef } from "@angular/core";
import { FormGroup, FormBuilder, FormControl, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NavController, NavParams, LoadingController, ModalController, IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ConfigProvider } from "src/app/services/config/config";
import { MdaProvider } from "src/app/services/mda/mda";
import { format } from "date-fns";
import { CommonModule } from "@angular/common";
import { ProverDatepickerComponent } from "src/app/components/prover-datepicker/prover-datepicker";
import { ProverHorasComponent } from "src/app/components/prover-horas/prover-horas.component";
import { noWhitespaceValidator } from "src/app/pipes/no-white-space-validator/no-white-space-validator";

@Component({
  selector: "app-mda-encontro",
  templateUrl: "./mda-encontro.page.html",
  styleUrls: ["./mda-encontro.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ReactiveFormsModule,
    TranslateModule,
    ProverDatepickerComponent,
    ProverHorasComponent,
  ],
})
export class MdaEncontroPage implements OnInit {
  validations_form: FormGroup;
  idMda: string = "";
  idMdaEncontroTipo: string = "";
  dateTime: any = format(new Date(), "yyyy-MM-dd");
  hourTime: any = format(new Date(), "HH:mm");
  dataRetroativa = false;
  horaRetroativa = false;
  mesmaData = true;
  showStatus = false;
  statusList: any = [
    { id: 1, nome: this.translate.instant("Realizado") },
    { id: 2, nome: this.translate.instant("Não Realizado") },
    { id: 3, nome: this.translate.instant("Desmarcado") },
  ];
  validation_messages = {
    data: [{ type: "required", message: this.translate.instant("A data deve ser informada") }],
    hora: [{ type: "required", message: this.translate.instant("A hora deve ser informada") }],
    descricao: [
      { type: "required", message: this.translate.instant("A descrição deve ser informada") },
      { type: "whitespace", message: this.translate.instant("O descrição não pode conter apenas espaços.") },
    ],
    status: [{ type: "required", message: this.translate.instant("O status deve ser informado") }],
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public loadingController: LoadingController,
    public mdaProvider: MdaProvider,
    public modalCtrl: ModalController,
    public formBuilder: FormBuilder,
    private translate: TranslateService,
    public configProvider: ConfigProvider
  ) {
    this.idMda = this.navParams.get("idMda");
    this.idMdaEncontroTipo = this.navParams.get("idMdaEncontroTipo");
    this.validations_form = this.formBuilder.group({
      data: new FormControl(this.dateTime, Validators.required),
      hora: new FormControl(this.hourTime, Validators.required),
      descricao: new FormControl("", [Validators.required, noWhitespaceValidator]),
      status: new FormControl(0, Validators.nullValidator),
    });
  }

  ngOnInit() {
    this.validations_form.get("hora")?.valueChanges.subscribe((valor) => {
      this.horaRetroativa = valor < this.hourTime;
      this.atualizarStatus();
    });

    this.validations_form.get("data")?.valueChanges.subscribe((valor) => {
      this.dataRetroativa = new Date(valor) < new Date(this.dateTime);
      this.mesmaData = valor == this.dateTime;
      this.atualizarStatus();
    });
  }

  atualizarStatus() {
    const statusControl = this.validations_form.get("status");

    (this.dataRetroativa && this.horaRetroativa) || (this.mesmaData && this.horaRetroativa) || this.dataRetroativa
      ? (statusControl?.setValidators([Validators.required]), statusControl?.setValue(null), (this.showStatus = true))
      : (statusControl?.clearValidators(), statusControl?.setValue(0), (this.showStatus = false));
    statusControl?.updateValueAndValidity();
  }

  onSubmit(encontro: { idMda: string; idMdaEncontroTipo: string }) {
    encontro.idMda = this.idMda;
    encontro.idMdaEncontroTipo = this.idMdaEncontroTipo;
    this.mdaProvider.salvarMda(encontro).subscribe(() => {
      this.modalCtrl.dismiss();
    });
  }

  public closeModal() {
    this.modalCtrl.dismiss();
  }
}
